import { render, staticRenderFns } from "./PaySlipConfiugration.vue?vue&type=template&id=0743fa00&"
import script from "./PaySlipConfiugration.vue?vue&type=script&lang=js&"
export * from "./PaySlipConfiugration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports